export default {
  STORE_PATTERN: "STORE_PATTERN",
  GET_PATTERNS: "GET_PATTERNS",
  GET_PATTERN_BY_ID: "GET_PATTERN_BY_ID",
  UPDATE_PATTERN_GROUPS: "UPDATE_PATTERN_GROUPS",
  GET_PATTERN_GROUPS_MAINTENANCE: "GET_PATTERN_GROUPS_MAINTENANCE"
};
